import { NgTemplateOutlet } from '@angular/common';
import { AfterContentInit, Component, inject, Input, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatFormField, MatOption, MatSelect, MatSelectChange, MatSelectModule, MatSuffix } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { SessionStorageService } from '@core';
import { SortPipe } from '@core';
import { IncidentTabStatusFilter } from '@models';
import { IncidentsFilterService } from '@services';
import { DatePickerComponent, MultipleSelectComponent, SearchInputComponent } from '@ui';
import { sub } from 'date-fns';

@Component({
  imports: [
    DatePickerComponent,
    FormsModule,
    MatButton,
    MatButtonModule,
    MatButtonToggle,
    MatButtonToggleGroup,
    MatFormField,
    MatIcon,
    MatProgressSpinner,
    MatSelectModule,
    MatSuffix,
    MatTooltip,
    MultipleSelectComponent,
    NgTemplateOutlet,
    ReactiveFormsModule,
    SearchInputComponent,
    SortPipe,
  ],
  selector: 'avs-incidents-table-desktop-filters',
  standalone: true,
  templateUrl: './incidents-table-desktop-filters.component.html',
})
export class IncidentsTableDesktopFiltersComponent implements AfterContentInit {
  @Input() filtersEnabled = false;
  @Input() dropdownFilters = true;
  @Input() resolvedIncidentsLoading = false;
  @Input() tableId!: string;
  @ViewChild('columnSelectRef') columnSelectRef!: MatSelect;
  incidentTabStatusFilterEnum = IncidentTabStatusFilter;

  protected minDate = sub(new Date(), { months: 1 });

  protected incidentsFilterService = inject(IncidentsFilterService);
  private sessionStorageService = inject(SessionStorageService);

  columnListUpdated($event: MatSelectChange) {
    this.incidentsFilterService.columnsChange($event);
    this.sessionStorageService.saveColumnsSettingsToSessionStorage(this.tableId, $event.value);
    this.incidentsFilterService.setColumnsValues();
  }

  selectAllColumns() {
    this.columnSelectRef.options.forEach((item: MatOption) => item.select());
  }

  ngAfterContentInit(): void {
    const columns = this.sessionStorageService.getColumns(this.tableId);

    if (columns?.length) {
      this.incidentsFilterService.displayedColumns = columns;
      this.incidentsFilterService.columnsChange({ value: columns } as MatSelectChange);
      this.columnListUpdated({ value: columns } as MatSelectChange);
    }
  }
}
